// Single source of truth for the order/dispute timings on the client.
//
// Three env vars, no duplicates, and every countdown in the app reads them
// from here — never `process.env` inline. They MUST match the backend's
// VOTING_LENGTH / DISPUTE_APPEAL_OPEN_TIME / AUTOCANCEL_TIME (midl-server
// src/config/order-timings.ts): the UI runs the countdown the user watches,
// the backend runs the gate and the sweep on the same numbers.
//
// CRA inlines these at build time, so a missing or empty var arrives as
// undefined/"" — Number() would then yield NaN/0 and silently break every
// countdown that multiplies by it. Coerce once here and fall back to the
// production values.
const positiveNumber = (raw, fallback) => {
  const parsed = Number(raw);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

// Number of jury votes on one side that decides a dispute.
export const VOTING_LENGTH = positiveNumber(process.env.REACT_APP_VOTING_LENGTH, 6);

// Minutes an appeal can be opened for after the dispute verdict.
export const DISPUTE_APPEAL_OPEN_TIME = positiveNumber(process.env.REACT_APP_DISPUTE_APPEAL_OPEN_TIME, 30);
export const DISPUTE_APPEAL_OPEN_TIME_MS = DISPUTE_APPEAL_OPEN_TIME * 60 * 1000;

// Minutes before an unconfirmed deposit order is auto-cancelled.
export const AUTOCANCEL_TIME = positiveNumber(process.env.REACT_APP_AUTOCANCEL_TIME, 30);
export const AUTOCANCEL_TIME_MS = AUTOCANCEL_TIME * 60 * 1000;

// A manual order cancel in flight: how often the order screen re-reads the order,
// and when it stops waiting. Above the server's worst case: each on-chain wait is
// bounded at 90 s and a healed cancel makes up to four.
export const CANCEL_PENDING_POLL_MS = 30 * 1000;
export const CANCEL_PENDING_GIVE_UP_MS = 7 * 60 * 1000;

export const DISPUTE_FEE = 5;

export const APPEAL_FEE = 10;
